import React from 'react';

const ResumenUI = () => {
  return (
    <div className=" bg-gray-100">

    </div>
  );
};

export default ResumenUI;